import { render, staticRenderFns } from "./ViewRideCreditModal.vue?vue&type=template&id=70b51054"
import script from "./ViewRideCreditModal.vue?vue&type=script&lang=ts"
export * from "./ViewRideCreditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports